import { useDispatch } from 'react-redux';
import MojitoServices from 'mojito/services';

const { actions: betslipActions } = MojitoServices.Betslip;

/**
 * HoC wraps CommitBetslipButton implementation with sports betslip specific handling.
 *
 * @function withSportSaveBet
 * @param {React.ReactElement} CommitBetslipButton - Save bet button view implementation.
 * @returns {React.ReactElement} Save bet button react component.
 * @memberof Mojito.Modules.BetslipView
 * @private
 */
export default function withSportSaveBet(CommitBetslipButton) {
    return function SaveSportBetButton(props) {
        const dispatch = useDispatch();

        const onSaveBet = () => dispatch(betslipActions.saveBetslip());
        const onAcceptPriceChanges = () => dispatch(betslipActions.acceptChanges());

        return (
            <CommitBetslipButton
                {...props}
                class="ta-SaveBetButton"
                onCommit={onSaveBet}
                onAcceptPriceChanges={onAcceptPriceChanges}
            />
        );
    };
}
